/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// reactstrap components
import { useState, useEffect } from "react";
import {
  Badge,
  Card,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  Pagination,
  PaginationItem,
  PaginationLink,
  Progress,
  Table,
  Container,
  Row,
  UncontrolledTooltip,
  Button,
} from "reactstrap";
// core components
import Header from "components/Headers/Header.js";
import Modal from "components/Modal";
import Uploadwill from "components/Uploadwill";
import { Input } from "antd";
import { DatePicker, Space } from "antd";
import { message, Popconfirm } from "antd";
import toast, { Toaster } from "react-hot-toast";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ["bold", "italic", "underline"],
    ["link", "image"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["clean"],
  ],
};

const Maps = () => {
  const [actualizarheader, setActualizarheader] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [value, setValue] = useState("");
  const [value2, setValue2] = useState("");

  const openModal = () => setIsOpen(true);
  const openModal2 = () => setIsOpen2(true);
  const closeModal = () => setIsOpen(false);
  const closeModal2 = () => {
    setIsOpen2(false);
    setIdgaleria(0);
  };

  const [files, setFiles] = useState([]);
  const [predicas, setPredicas] = useState([]);
  const [fechanueva, setFechanueva] = useState(null);
  const [fechanueva2, setFechanueva2] = useState(null);

  const [files2, setFiles2] = useState([]);
  const [idgaleria, setIdgaleria] = useState(0);
  const [titulo, setTitulo] = useState("");
  const [predicador, setPredicador] = useState("");
  const [link, setLink] = useState("");
  const [mensaje, setMensaje] = useState("");

  const onChange = (date, dateString) => {
    console.log(date, dateString);
    setFechanueva(dateString);
  };

  const onChange2 = (date, dateString) => {
    console.log(date, dateString);
    setFechanueva2(dateString);
  };

  const confirm = (id) => {
    console.log(id);

    const data = {
      id: id,
      token: localStorage.getItem("token"),
    };
    fetch(`${process.env.REACT_APP_API}/deletepredicas`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.message) {
          if (result.message == "Predica Eliminada con Exito") {
            message.success(result.message);
            obtenergaleria();
          } else {
            message.error(result.message);
          }
        } else {
          console.log(result.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const cancel = (e) => {
    console.log(e);
  };

  const guardargaleria = (event) => {
    if (fechanueva == null) {
      toast.error("Debes ingresar una Fecha");
      return;
    }

    if (document.getElementById("titulo_predicas").value == "") {
      toast.error("Debes ingresar un Titulo de Predica");
      return;
    }

    if (document.getElementById("nombre_predicas").value == "") {
      toast.error("Debes ingresar el Nombre del Predicador");
      return;
    }

    if (value == "") {
      toast.error("Debes ingresar un Mensaje de la Predica");
      return;
    }

    if (files.length > 1) {
      toast.error("Debes Subir solo una imagen");
      return;
    }

    if (files.length == 0) {
      toast.error("Debes Subir una Imagen de Portada");
      return;
    }

    const data = {
      token: localStorage.getItem("token"),
      titulo: document.getElementById("titulo_predicas").value,
      nombre: document.getElementById("nombre_predicas").value,
      link: document.getElementById("link_predicas").value,
      mensaje: value,
      fecha: fechanueva,
      foto: files,
    };
    fetch(`${process.env.REACT_APP_API}/predicas`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.message) {
          console.log(result.message);

          if (result.message == "guardado") {
            toast.success("Predica agregada con exito");
            setFiles([]);
            obtenergaleria();
            closeModal();
          } else {
            toast.error(result.message);
          }
        } else {
          console.log(result.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const actualizargaleria = (event) => {
    if (document.getElementById("titulo_predicast").value == "") {
      toast.error("Debes ingresar un Titulo de Predica");
      return;
    }

    if (document.getElementById("nombre_predicast").value == "") {
      toast.error("Debes ingresar el Nombre del Predicador");
      return;
    }

    if (mensaje == "") {
      toast.error("Debes ingresar un Mensaje de la Predica");
      return;
    }

    if (files2.length > 1) {
      toast.error("Debes Subir solo una imagen");
      return;
    }

    if (files2.length == 0) {
      toast.error("Debes Subir una Imagen de Portada");
      return;
    }

    const data = {
      token: localStorage.getItem("token"),
      titulo: document.getElementById("titulo_predicast").value,
      nombre: document.getElementById("nombre_predicast").value,
      link: document.getElementById("link_predicast").value,
      mensaje: mensaje,
      id: idgaleria,
      foto: files2,
    };

    console.log(document.getElementById("link_predicast").value);

    fetch(`${process.env.REACT_APP_API}/actualizarpredicas`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.message) {
          console.log(result.message);

          if (result.message == "modificado") {
            toast.success("Predica agregada con exito");
            setMensaje("");
            obtenergaleria();
            closeModal2();
          } else {
            toast.error(result.message);
          }
        } else {
          console.log(result.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const obtenergaleria = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API}/obtenerpredicas/`
      );
      if (!response.ok) {
        throw new Error("Error en la red");
      }
      const data = await response.json();
      if (data) {
        setPredicas(data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setActualizarheader(!actualizarheader);
  };

  function formatearFecha(fechaString) {
    const opciones = {
      day: "2-digit",
      month: "short",
      hour12: true,
    };

    const fecha = new Date(fechaString);

    if (!(fecha instanceof Date) || isNaN(fecha)) {
      console.error("Valor de fecha inválido:", fecha);
      return "Fecha inválida"; // O maneja el error de otra manera
    }

    ////console.log(new Intl.DateTimeFormat('es-ES', opciones).format(fecha))

    return new Intl.DateTimeFormat("es-ES", opciones).format(fecha);
  }

  useEffect(() => {
    console.log("VIENDO LOS ARCHIVOS AFUERA");
    console.log(files);
  }, [files]);

  useEffect(() => {
    obtenergaleria();
  }, []);

  useEffect(() => {
    if (idgaleria !== 0) {
      for (let i = 0; i < predicas.length; i++) {
        console.log(predicas[i].ID);
        if (idgaleria == predicas[i].ID) {
          setTitulo(predicas[i].Titulo);
          setLink(predicas[i].Link);
          setPredicador(predicas[i].Predicador);
          setMensaje(predicas[i].Contenido);
          setFiles2(JSON.parse(predicas[i].Foto));
        }
      }
    }
    console.log(idgaleria);
  }, [idgaleria]);

  useEffect(() => {
    console.log(mensaje);
    if (mensaje !== "") {
      console.log(" mensajesss");
      openModal2();
    }
  }, [mensaje]);

  return (
    <>
      <Header act={actualizarheader} />
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <h3 className="mb-0">Galeria de Imagenes de Eventos</h3>
                <div className="col text-right">
                  <Button
                    color="primary"
                    size="sm"
                    onClick={() => {
                      openModal();
                    }}
                  >
                    Nuevo Evento
                  </Button>
                </div>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">Fecha</th>
                    <th scope="col">Predicador</th>
                    <th scope="col">Titulo</th>
                    <th scope="col" />
                  </tr>
                </thead>
                <tbody>
                  {predicas.map((val, key) => {
                    return (
                      <tr>
                        <th scope="row">{formatearFecha(val.Fecha)}</th>
                        <td>{val.Predicador}</td>
                        <td>{val.Titulo}</td>
                        <td>
                          <svg
                            onClick={() => {
                              setIdgaleria(val.ID);
                            }}
                            class="w-6 h-6 text-gray-800"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                            title="Editar"
                            style={{ cursor: "pointer" }}
                          >
                            <path
                              fill-rule="evenodd"
                              d="M11.32 6.176H5c-1.105 0-2 .949-2 2.118v10.588C3 20.052 3.895 21 5 21h11c1.105 0 2-.948 2-2.118v-7.75l-3.914 4.144A2.46 2.46 0 0 1 12.81 16l-2.681.568c-1.75.37-3.292-1.263-2.942-3.115l.536-2.839c.097-.512.335-.983.684-1.352l2.914-3.086Z"
                              clip-rule="evenodd"
                            />
                            <path
                              fill-rule="evenodd"
                              d="M19.846 4.318a2.148 2.148 0 0 0-.437-.692 2.014 2.014 0 0 0-.654-.463 1.92 1.92 0 0 0-1.544 0 2.014 2.014 0 0 0-.654.463l-.546.578 2.852 3.02.546-.579a2.14 2.14 0 0 0 .437-.692 2.244 2.244 0 0 0 0-1.635ZM17.45 8.721 14.597 5.7 9.82 10.76a.54.54 0 0 0-.137.27l-.536 2.84c-.07.37.239.696.588.622l2.682-.567a.492.492 0 0 0 .255-.145l4.778-5.06Z"
                              clip-rule="evenodd"
                            />
                          </svg>
                          <Popconfirm
                            title="Eliminar Esta Predica"
                            description="Deseas borrar este registro?"
                            onConfirm={() => {
                              confirm(val.ID);
                            }}
                            onCancel={cancel}
                            okText="Yes"
                            cancelText="No"
                          >
                            <svg
                              class="w-6 h-6"
                              style={{ color: "red", cursor: "pointer" }}
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              fill="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M8.586 2.586A2 2 0 0 1 10 2h4a2 2 0 0 1 2 2v2h3a1 1 0 1 1 0 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8a1 1 0 0 1 0-2h3V4a2 2 0 0 1 .586-1.414ZM10 6h4V4h-4v2Zm1 4a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0v-8Zm4 0a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0v-8Z"
                                clip-rule="evenodd"
                              />
                            </svg>
                          </Popconfirm>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </Card>
          </div>
        </Row>
      </Container>
      <Modal isOpen={isOpen} onClose={closeModal}>
        <div
          style={{
            flex: 1,
            display: "flex",
            justifyContent: "left",
            alignItems: "left",
            color: "#006633",
          }}
        >
          <svg
            class="w-6 h-6 text-gray-800 "
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              fill-rule="evenodd"
              d="M7.5 4.586A2 2 0 0 1 8.914 4h6.172a2 2 0 0 1 1.414.586L17.914 6H19a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h1.086L7.5 4.586ZM10 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm2-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z"
              clip-rule="evenodd"
            />
          </svg>

          <h5 style={{ color: "#006633" }}> &nbsp; Registro de Predicas</h5>
        </div>
        <div>Titulo de Predicación</div>
        <Input id="titulo_predicas" placeholder="" />
        <div>Nombre del Predicador</div>
        <Input id="nombre_predicas" placeholder="" />
        <div>Fecha del Evento</div>
        <DatePicker id="fecha_predicas" onChange={onChange} />
        <div>Link de Youtube (Opcional)</div>
        <Input id="link_predicas" placeholder="" />

        <div>Foto Portada</div>
        <Uploadwill
          name="Foto"
          id="fotos_add"
          files={files}
          setFiles={setFiles}
        />
        <div>Mensaje</div>
        <ReactQuill theme="snow" value={value} onChange={setValue} />

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "end",
            alignItems: "end",
          }}
        >
          <Button
            color="primary"
            size="sm"
            onClick={() => {
              guardargaleria();
            }}
            style={{ width: "200px" }}
          >
            Nuevo Evento
          </Button>
        </div>
      </Modal>

      <Modal isOpen={isOpen2} onClose={closeModal2}>
        <div
          style={{
            flex: 1,
            display: "flex",
            justifyContent: "left",
            alignItems: "left",
            color: "#006633",
          }}
        >
          <svg
            class="w-6 h-6 text-gray-800 "
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              fill-rule="evenodd"
              d="M7.5 4.586A2 2 0 0 1 8.914 4h6.172a2 2 0 0 1 1.414.586L17.914 6H19a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h1.086L7.5 4.586ZM10 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm2-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z"
              clip-rule="evenodd"
            />
          </svg>

          <h5 style={{ color: "#006633" }}> &nbsp; Registro de Predicas</h5>
        </div>
        <div>Titulo de Predicación</div>
        <Input id="titulo_predicast" placeholder="" defaultValue={titulo} />
        <div>Nombre del Predicador</div>
        <Input id="nombre_predicast" placeholder="" defaultValue={predicador} />
        <div>Link de Youtube (Opcional)</div>
        <Input id="link_predicast" placeholder="" defaultValue={link} />
        <div> Foto de Portada </div>
        <Uploadwill
          name="Foto"
          id="fotos_act"
          files={files2}
          setFiles={setFiles2}
        />
        <div>Mensaje</div>
        <ReactQuill theme="snow" value={mensaje} onChange={setMensaje} />

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "end",
            alignItems: "end",
          }}
        >
          <Button
            color="primary"
            size="sm"
            onClick={() => {
              actualizargaleria();
            }}
            style={{ width: "200px" }}
          >
            Actualizar Predica
          </Button>
        </div>
      </Modal>
      <Toaster />
    </>
  );
};

export default Maps;
